module.exports = __webpack_public_path__ + "img/no-item2.798594ec.png";